import React, { useState } from 'react';
import './NavBar.css';
import { FaBars } from 'react-icons/fa';
import logoMel from '../asset/image/Logo_Mel_transp.png';



const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="navbar">
              <div className='logoTitreHeader'>
                <img src={logoMel} alt="logoMel" className='logoMel'/>
                <h1 className='titreHeader'>Les Tontons Friteurs</h1>
              </div>

      {/* Bouton menu burger (visible uniquement sur mobile) */}
      <button className="burger-button" onClick={toggleMenu}>
        {/* ☰ */}
      <FaBars className="burger-icon" onClick={toggleMenu} />
      </button>


      {/* Liste des liens */}
      <ul className={`nav-list ${isOpen ? 'open' : ''}`}>
        <li className="nav-item"><a href="/" className="nav-link" onClick={() => setIsOpen(false)}>Accueil</a></li>

        <li className="nav-item"><a href="/#a_propos" className="nav-link" onClick={() => setIsOpen(false)}>À propos</a></li>

        <li className="nav-item"><a href="/#savoir" className="nav-link" onClick={() => setIsOpen(false)}>Infos</a></li>

        <li className="nav-item"><a href="/#temoignages" className="nav-link" onClick={() => setIsOpen(false)}>Vos avis</a></li>

        <li className="nav-item"><a href="/#faq" className="nav-link" onClick={() => setIsOpen(false)}>F.A.Q.</a></li>

        <li className="nav-item"><a href="/#contacts" className="nav-link" onClick={() => setIsOpen(false)}>Contact</a></li>
      </ul>
    </nav>
  );
};

export default Navbar;
